var map = {
	"./icon-baoyu.png": "9f72",
	"./icon-bingbao.png": "fbea",
	"./icon-chenxue.png": "929a",
	"./icon-daxue.png": "d144",
	"./icon-dayu.png": "7796",
	"./icon-duoyun.png": "ec79",
	"./icon-kulian.png": "3b3d",
	"./icon-leizhenyu.png": "e62a",
	"./icon-qing.png": "6446",
	"./icon-shachen.png": "7a0d",
	"./icon-wu.png": "9db7",
	"./icon-wuxinxi.png": "d076",
	"./icon-xiaoxue.png": "2c9c",
	"./icon-xiaoyu.png": "8fc5",
	"./icon-yewanduoyun.png": "3012",
	"./icon-yewanqing.png": "c9f9",
	"./icon-yintian.png": "4911",
	"./icon-yujiaxue.png": "c134",
	"./icon-zhenyu.png": "4b68",
	"./icon-zhongxue.png": "7aae",
	"./icon-zhongyu.png": "ea10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33ac";